import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/globals.css'

// FOUC prevention: apply theme before first render.
// Reads the saved preference from localStorage and resolves 'system' via matchMedia.
;(() => {
  const saved = localStorage.getItem('pmp_theme') ?? 'system'
  const resolved =
    saved === 'system'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
      : saved
  document.documentElement.setAttribute('data-theme', resolved)
})()

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)

// Bootstrap the theme store (sets up the OS-change watcher)
import { useThemeStore } from './stores/theme'
useThemeStore(pinia)

app.mount('#app')
